import React from 'react';
import isBlank from '../utilities/isBlank';
import isNonNegativeNumber from '../utilities/isNonNegativeNumber';
import isNaturalNumber from '../utilities/isNaturalNumber';
import currencySym from 'currency-symbol-map';
import { map } from 'lodash';
import { FormattedMessage, FormattedNumber } from 'react-intl';

const validateAddItemsForm = (values, props) => {
  const { addOns = [] } = values;
  const { currency = 'USD' } = props;

  const errors = map(addOns, addOn => {
    if (addOn) {
      return {
        title: isBlank(addOn.title),
        count: 9999 < Number(addOn.count)
          ? <FormattedMessage id='inbox.validate_add_items_form.quantity_less' defaultMessage='Enter a quantity less than {num}' values={{ num: <FormattedNumber value={9999} /> }} />
          : isBlank(addOn.count, 'Required') || isNaturalNumber(addOn.count, 'Invalid'),
        unit_cost: 999999 < Number(addOn.unit_cost)
          ? <FormattedMessage id='inbox.validate_add_items_form.price_less' defaultMessage='Enter a price less than {num}' values={{ num: <FormattedNumber value={999999} currency={currency} style='currency' /> }} />
          : isBlank(addOn.unit_cost, 'Required') || isNonNegativeNumber(addOn.unit_cost, 'Invalid')
      };
    }

    return {
      title: true
    };
  });

  return {
    addOns: errors
  };
};

export default validateAddItemsForm;
